"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const List_1 = __importDefault(require("@material-ui/core/List"));
const ListSubheader_1 = __importDefault(require("@material-ui/core/ListSubheader"));
const SwipeableDrawer_1 = __importDefault(require("@material-ui/core/SwipeableDrawer"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const ExitToApp_1 = __importDefault(require("@material-ui/icons/ExitToApp"));
const Menu_1 = __importDefault(require("@material-ui/icons/Menu"));
const user_context_1 = require("../../../providers/user/user-context");
const menubar_context_1 = require("../menubar-context");
const drawer_context_1 = require("./drawer-context");
const drawer_item_1 = require("./drawer-item");
const drawer_styles_1 = require("./drawer-styles");
const drawer_utils_1 = require("./drawer-utils");
function Drawer({ items, handleLogoClick, logo }) {
    const classes = (0, drawer_styles_1.useStyles)();
    const { drawerTitleRef } = (0, react_1.useContext)(menubar_context_1.MenubarContext);
    const { user, logout } = (0, react_1.useContext)(user_context_1.UserContext);
    const [open, setOpen] = (0, react_1.useState)(false);
    const [collapseState, setCollapseState] = (0, react_1.useState)((0, drawer_utils_1.deriveCollapseState)(items));
    const toggleDrawer = (open) => (event) => {
        if (event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' ||
                event.key === 'Shift')) {
            return;
        }
        setOpen(open);
    };
    const handleCollapseState = (id) => {
        if (collapseState[id] === undefined) {
            return;
        }
        setCollapseState({
            ...collapseState,
            [id]: !collapseState[id],
        });
    };
    return (react_1.default.createElement(drawer_context_1.DrawerContext.Provider, { value: { open, setOpen, collapseState, handleCollapseState } },
        react_1.default.createElement("div", { className: classes.menuBarWrapper },
            react_1.default.createElement("div", { className: classes.menuBarTitle, ref: drawerTitleRef },
                react_1.default.createElement(Typography_1.default, { variant: "h6", noWrap: true },
                    react_1.default.createElement("a", { className: classes.iconlink, onClick: handleLogoClick }, logo))),
            react_1.default.createElement(Button_1.default, { onClick: toggleDrawer(true), style: { height: 62 } },
                react_1.default.createElement(Menu_1.default, { style: { color: 'white' } })),
            react_1.default.createElement(SwipeableDrawer_1.default, { anchor: "right", open: open, onClose: toggleDrawer(false), onOpen: toggleDrawer(true), PaperProps: { style: { width: '80%' } } },
                react_1.default.createElement(List_1.default, { subheader: react_1.default.createElement(ListSubheader_1.default, { className: classes.drawerHeader },
                        react_1.default.createElement("div", { className: classes.drawerUserInfo }, user === null || user === void 0 ? void 0 :
                            user.name,
                            react_1.default.createElement(Button_1.default, { className: classes.menuBarButton, onClick: () => logout() },
                                react_1.default.createElement(ExitToApp_1.default, null))),
                        react_1.default.createElement("div", { className: classes.drawerDivider }, "MENU")) }, items.map((item) => {
                    const id = (0, drawer_utils_1.getIdForMenuItem)(item);
                    if (!id) {
                        return null;
                    }
                    return (react_1.default.createElement(react_1.default.Fragment, { key: id },
                        react_1.default.createElement(drawer_item_1.DrawerItem, { item: item, level: 1 })));
                }))))));
}
exports.Drawer = Drawer;
//# sourceMappingURL=drawer.js.map